import { render, staticRenderFns } from "./ThemeSwitcher.vue?vue&type=template&id=03ffceb0&"
import script from "./ThemeSwitcher.vue?vue&type=script&lang=js&"
export * from "./ThemeSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports